import { Moment } from 'moment';

export class CustomerNote {
	noteId: number;
	comment: string;
	addedBy: string;
	createdOn: Moment | string;
}

export interface NewCustomerNote {
	comment: string;
}

